module.exports = __webpack_public_path__ + "img/backyard-side-door.21532045.jpg";